/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react' //, {useState}
import FortiDevicesCrud from '../../../modules/Fortinet/Devices/Fortine_Devices'
import ModalSwal from '../../../modules/permisoDenegado/Modalswal'
import { useAppSelector } from '../../../../redux/hooks'

const FortiDevices: React.FC = () => {
  const ListaPermisosTenant= useAppSelector(state=> state.ListPermissionSlice.Permissions)
  const MostrarModal=ListaPermisosTenant.length!==0&&!ListaPermisosTenant.includes('Ctx.NGFW.List')
  return (
    <>
      {/*<div className="d-flex flex-column-auto h-60px bg-info-td border-rounded flex-center border rounded">
        <h3 className='text-secondary'> Roles List</h3>
      </div>
  */}
            <ModalSwal show={MostrarModal}></ModalSwal>

      <div  className='card mb-5 mb-xl-5'>
          <FortiDevicesCrud></FortiDevicesCrud>
      </div>
    </>
  )
}

export {FortiDevices}
